import { observer } from "mobx-react";
import PolicyFeeStore from "../../../../stores/policy-fee-store";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import { AMOUNT_TYPE, FEE_TYPE } from "../../../../policy-types";
import { IOption, SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import currentPortalStore from "../../../../../../stores/current-portal-store";
import { Input } from "../../../../../../components/inputs/input/input";
import './amount-settings.scss';

interface IProps {
    fee: PolicyFeeStore;
    validationGroup: IValidationGroup;
}

const AmountSettings: React.FC<IProps> = observer(({ fee, validationGroup }) => {
    const amountOptions = fee.amountOptions as IOption[];

    return (
        <div className="amount-settings">
            <div>
            {
                fee.feeType !== FEE_TYPE.COST && (
                    <div className="amount">
                        {fee.hasEditableAmount ?
                            <SelectDropdown
                                value={amountOptions.find(o => o.value === fee.amountType)}
                                options={amountOptions}
                                onChange={(v) => v?.value && fee.setAmountType(v.value as AMOUNT_TYPE)}
                                validationGroup={validationGroup}
                                required
                                isSearchable={false}
                            /> :
                            <FontBody2>Fixed amount</FontBody2>}
                        <div className="price">
                            {!fee.hasPercentageAmount && currentPortalStore.setting?.currencyCode}
                            <Input
                                value={fee.amount} 
                                onChange={fee.setAmount} 
                                validationGroup={validationGroup}
                                validationCallback={fee.validateFee}
                                type="number"
                                required
                            />
                            {fee.hasPercentageAmount && '%'}
                        </div>
                    </div>
                )
            }
            </div>
        </div>
    );
});

export default AmountSettings;